import React, { useEffect, useRef } from "react";
import { cn } from "@/lib/utils";
import { useLocation } from "react-router-dom";

export interface ScrollContainerProps extends React.HTMLAttributes<HTMLDivElement> {
  snapType?: "y" | "x" | "both" | "none";
  snapBehavior?: "mandatory" | "proximity";
}

const ScrollContainer = React.forwardRef<HTMLDivElement, ScrollContainerProps>(
  (
    {
      className,
      snapType = "y",
      snapBehavior = "mandatory",
      children,
      ...props
    },
    ref
  ) => {
    const location = useLocation();
    const internalRef = useRef<HTMLDivElement>(null);
    const scrollRef = (ref as React.RefObject<HTMLDivElement>) || internalRef;

    useEffect(() => {
      if (scrollRef.current) {
        scrollRef.current.scrollTo({ top: 0, behavior: "auto" });
      }
    }, [location.pathname]);

    const containerClasses = cn(
      "scroll-smooth w-full",
      snapType === "y" && `snap-${snapBehavior} snap-y`,
      snapType === "x" && `snap-${snapBehavior} snap-x`,
      snapType === "both" && `snap-${snapBehavior} snap-both`,
      snapType === "none" && "snap-none",
      className
    );

    return (
      <div ref={scrollRef} className={containerClasses} {...props}>
        {children}
      </div>
    );
  }
);

ScrollContainer.displayName = "ScrollContainer";

export { ScrollContainer };